import Layout from '@/apps/layout/components'
import Lesson from '@/apps/Lesson'
import React from 'react'

const LessonPage = (): React.ReactElement => {
  return (
    <Layout>
      <Lesson />
    </Layout>
  )
}

export default LessonPage
